import { apiRequest } from '@/core';
import { type FetchEventPayload } from '@/slices/events/types';
import { type Incident } from '@/types';

export const fetchIncidentsRequest = async ({ eventId }: FetchEventPayload) =>
  apiRequest<Incident[]>({
    endpoint: `api/incidents/event/${eventId}`,
  });
